<template>
  <section id="program" ref="program">
    <div class="big spacer half">
      <div class="title mbig">{{ program.title }}</div>
      <div class="pt pb bb" v-html="program.friday"></div>
      <div class="pt pb" v-html="program.saturday"></div>
      <div v-if="program.documents.length > 0" class="pt bt">
        <div v-for="(document, index) in program.documents" :key="index">
          <a :href="document.url" target="_blank">&rarr; {{ document.title ? document.title : document.filename }}</a>
        </div>
      </div>
    </div>

    <div
      id="friday"
      class="spacer"
      v-if="program.eventsfriday && program.eventsfriday.length > 0"
    >
      <div class="big mbig title">{{ $t("friday") }}</div>
      <collapse
        v-for="item in program.eventsfriday"
        :key="'fri-' + item.title"
        :uid="item.uid"
        parent="program"
        :fold="true"
      >
        <template v-slot:header>
          <div class="grid large first">
            <div>{{ item.title }}</div>
            <div class="pr4">
              <span v-for="speaker in item.speaker" :key="speaker.name">
                {{ speaker.name }}<br />
              </span>
            </div>
          </div>   
        </template>
        <template v-slot:content>
          <div class="grid large">
            <div></div>
            <div>
              <div
                class="grid mobile mb"
                v-for="speaker in item.speaker"
                :key="speaker.name"
              >
                <div>
                  <img
                    v-if="speaker.image"
                    :src="speaker.image.url"
                    :alt="speaker.name"
                  />
                </div>
                <div v-html="speaker.bio" class="pr2"></div>
              </div>
              <div class="big mb bt pt">{{ item.hour }}h, {{ item.stage }}</div> 
              <div v-html="item.description"></div>
            </div>
          </div>          
        </template>
      </collapse>
    </div>

    <div
      id="saturday"
      class="spacer"
      v-if="program.eventssaturday && program.eventssaturday.length > 0"
    >
      <div class="big mbig title">{{ $t("saturday") }}</div>
      <collapse
        v-for="item in program.eventssaturday"
        :key="'sat-' + item.title"
        :uid="item.uid"
        :fold="true"
      >
        <template v-slot:header>
          <div class="grid large first">
            <div>{{ item.title }}</div>
            <div class="pr4">
              <span v-for="speaker in item.speaker" :key="speaker.name">
                {{ speaker.name }}<br />
              </span>
            </div>
          </div>   
        </template>
        <template v-slot:content>
          <div class="grid large">
            <div></div>
            <div>
              <div
                class="grid mobile mb"
                v-for="speaker in item.speaker"
                :key="speaker.name"
              >
                <div class="small">
                  <img
                    v-if="speaker.image"
                    :src="speaker.image.url"
                    :alt="speaker.name"
                  />
                </div>
                <div v-html="speaker.bio" class="pr2"></div>
              </div>
              <div class="big mb bt pt">{{ item.hour }}h, {{ item.stage }}</div> 
              <div v-html="item.description"></div>
            </div>
          </div>          
        </template>
      </collapse>
    </div>
  </section>
</template>

<script>
import API from "@/api/service";
import Collapse from "@/components/Collapse.vue";
export default {
  components: {
    Collapse
  },
  data() {
    return {
      program: [],
      loaded: false
    };
  },
  watch: {
    $route() {
      API.program(this.$i18n.locale).then(page => {
        this.program = page.data.result;
      });
    }
  },
  created() {
    API.program(this.$i18n.locale).then(page => {
      this.program = page.data.result;
      this.loaded = true;
    });
  },
  mounted() {
    if (this.$route.params.pathMatch == "program") {
      if (this.loaded) {
        this.$scrollTo("#" + this.$route.params.pathMatch, 1000);
      }
    }
  }
};
</script>

<style>
.full-width {
  position:relative;
  /* width:100vw; */
  /* margin-left:-50%; */
}
</style>
